"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QMSInlineCommentMark = void 0;
const core_1 = require("@tiptap/core");
const NAME = 'node-uuid';
/**
 * @public
 */
exports.QMSInlineCommentMark = core_1.Mark.create({
    name: NAME,
    inline: true,
    parseHTML() {
        return [
            {
                tag: `span[${NAME}]`
            }
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', HTMLAttributes, 0];
    }
});
//# sourceMappingURL=qmsInlineCommentMark.js.map